import React, { Component } from 'react';
import { FormGroup, Input, Button, Badge, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import CounterInput from '../../components/reusable/CounterInput';
import c from '../../constants/Colors';
import product from '../../assets/img/product.png';
import Pagination from '../reusable/Pagination'
import { BuscarProductoMasComprado } from '../../store/sagas/pedidoApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion } from '../../utilitarios/util';
import { data } from '../../constants/Constants';
import { AgregarProductoFavorito } from '../../store/sagas/favoritoApi';
import { AgregarProductoPedido } from '../../store/sagas/carritoApi';
import { AuthContext } from "../../store/provider/AuthProvider";
import ModalAddCart from "../reusable/modals/AddCart";
import ModalImageZoom from '../reusable/modals/ImageZoom';
import Spinner from "../reusable/Loader";
import CardPrecios from '../reusable/CardPrecios';
import TooltipLeyenda from '../reusable/TooltipLeyenda';

const CardProduct = ({ item, postAgregarProductoFavorito, postAgregarProductoPedido, setCounter, auth, zoom }) => {
  return (
    <div className="card_product_horizontal mb-card-d">
      <div className="cphLeftImage">
        <img src={item.pathI} style={{ cursor: 'pointer' }} onClick={() => zoom(item.pathI)} />
      </div>
      <div className="cphTextCenter">
        <h6 className="paragraph-2 bold mb-1" style={{ color: c.azulClaro }}>{item.maktx}</h6>
        <span className="paragraph-3 mb-3" style={{ color: c.azulClaro }}>SKU: {item.matnr}</span>
        {/* <span className="paragraph-3 previousPrice" style={{ color: c.grisOscuro }}>{item.precioPublico}</span> */}
        {/* <strong className="paragraph-3 bold naranja">{item.precioPVD}</strong>
        <span className="paragraph-3">{item.precioPVP}</span> */}
        <CardPrecios data={item.precios} escalas={item.escalas} cantidad={item.cantidad} className="cardPrice" />
        <div className="text-left mt-3">
          <button className='btn-icon'
            type="button"
            onClick={() => postAgregarProductoFavorito(item, item.favorito, item.indice)}
          >
            <SvgAssets icon="icon-star" fill={item.favorito ? c.amarillo : c.celeste} />
          </button>
        </div>
      </div>
      <div className="cphCounterInput gradient_blue" style={{ justifyContent: 'space-between' }}>
        <CounterInput
          vertical
          background={'transparent'}
          color={"#fff"}
          borderColor={"#fff"}
          data={item}
          eventCounter={setCounter}
        />
        <button className={`btn-icon mt-3${(item.cantidad == 0 ? " disabled" : "")}`}
          disabled={item.cantidad == 0}
          onClick={() => postAgregarProductoPedido(auth.carritoProdctos, auth.setcarritoProdctos, item, data.Pantalla.Catalogo.ProductosVendidos)}
        >
          <SvgAssets icon="icon-add-cart" />
        </button>
      </div>
    </div>
  )
}

export class ProductosVendidos extends Component {
  static displayName = ProductosVendidos.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dealer: {},
      linea: {},
      asociado: {},
      productosMasComprados: [],
      // page: 1,
      // size: data.PageSize,
      // currentPage: 1,
      dataResult: [],
      productosMasCompradosFiltrados: [],
      addToCart: false,
      dataToCard: {},
      modalZoom: false,
      imgZoom: "",
    };
  }

  showModalCart = () => {
    this.setState(prevState => ({
      addToCart: !prevState.addToCart
    }));
  }

  toggleModalZoom = (img) => {
    this.setState(prevState => ({
      modalZoom: !prevState.modalZoom,
      imgZoom: img
    }));
  }

  showCarrito = () => {
    this.setState({ addToCart: false, loading: true }, () => {
      setTimeout(() => {
        this.setState({ loading: false })
        this.props.history.push('/carrito');
      }, 1000);
    });
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    let data = localStorageCustom.prototype.getUsuario()
    this.setState({ dealer: data.dealer, linea: data.linea, asociado: data.asociado }, () => {
      this.postBuscarProductoMasComprado(data.dealer, data.linea, data.asociado);
    })
  }

  postBuscarProductoMasComprado(dealer, linea, asociado) {

    BuscarProductoMasComprado(linea.vkorg, dealer.codcliente,
      dealer.correoElectronico, asociado.poblacion,
      asociado.moneda, linea.centro)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({
            loading: false,
            productosMasComprados: result.dto.productosMasComprados,
            productosMasCompradosFiltrados: result.dto.productosMasComprados
          })
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }

  render() {
    const { loading, productosMasCompradosFiltrados } = this.state;
    const auth = this.context;
    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Productos más comprados</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/dashboard' style={{ pointerEvents: 'none' }}>Catálogo de Repuestos</Link></li>
              <li><Link to='/historial-pedidos' style={{ pointerEvents: 'none' }}>Productos más comprados</Link></li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <div className="card_desktop">
            <div className="desktop">
              <TooltipLeyenda
                color={c.azulClaro}
                style={{ marginLeft: 'auto', top: -15, position: 'relative', width: 'max-content' }}
              />
            </div>
            <FormGroup className="icon mb-4" style={{ maxWidth: 255, margin: 'auto' }}>
              <Input className="" type='text' placeholder="SKU o Descripción"
                onChange={(text) => this.searchProductos(text)}
              />
              <Button color="link" className="btn-icon">
                <SvgAssets icon='icon-lupa' fill={c.azulClaro} />
              </Button>
            </FormGroup>
            <hr className="desktop mb-5" style={{ borderColor: '#E2E2E2' }} />
            <h6 className="title white mobile">
              Productos más comprados
              <TooltipLeyenda
                color={'#fff'}
                style={{ position: 'absolute', width: 'max-content', right: 0 }}
              />
            </h6>
            <div className="cards-wrap">
              {
                productosMasCompradosFiltrados.map((item, index) => {
                  return (
                    <CardProduct item={item} key={index} postAgregarProductoFavorito={this.postAgregarProductoFavorito} postAgregarProductoPedido={this.postAgregarProductoPedido} setCounter={this.setCounter} auth={auth} zoom={this.toggleModalZoom} />
                  );
                })
              }
            </div>
          </div>
          {/* {(productosMasCompradosFiltrados.length > 0) ? <Pagination event={this.setPage} current={page} currentPage={currentPage} totalPage={repuestos[0].totalPage} size={size} /> : null} */}
          {/* <Pagination /> */}
        </Container>
        <ModalAddCart dadComponent={this} dataToCard={this.state.dataToCard} />
        <ModalImageZoom dadComponent={this} />
      </div>
    );
  }

  setCounter = (counter, item, index) => {
    let dataIndex = this.state.productosMasCompradosFiltrados.findIndex(x => x.indice == index);
    let _destacados = this.state.productosMasCompradosFiltrados
    if (counter == "") {
      _destacados[dataIndex].cantidad = 0;
    } else { _destacados[dataIndex].cantidad = counter; }

    this.setState({
      productosMasCompradosFiltrados: _destacados,
      // productosMasComprados: _destacados
    })
  }

  // setPage = (index, change, type) => {
  //   if (change) {
  //     let _currentPage = this.state.currentPage
  //     this.setState({
  //       page: index,
  //       currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1)
  //     })
  //   }
  //   else
  //     this.setState({ page: index })


  //   this.setState({
  //     loading: true
  //   })
  //   this.postListarSistemaRepuestos(this.state.dealer, 
  //                                   this.state.linea, 
  //                                   this.state.asociado, 
  //                                   this.state.params, index);
  // }

  postAgregarProductoFavorito = async (item, AplicaFavorito, index) => {
    this.setState({ loading: true })

    let producto = {
      codigo: item.matnr,
      descripcion: item.maktx,
      moneda: item.waers,
      pantalla: data.Pantalla.BuscarPedidoVehiculo.Destacado
    };

    AgregarProductoFavorito(this.state.dealer, producto, this.state.linea, !AplicaFavorito)
      .then(result => {
        if (result.mo.type == "success") {
          this.setState({ loading: false })
          let dataIndex = this.state.productosMasCompradosFiltrados.findIndex(x => x.indice == index);
          let _destacados = this.state.productosMasCompradosFiltrados
          _destacados[dataIndex].favorito = !AplicaFavorito;

          this.setState({
            productosMasCompradosFiltrados: _destacados,
            // productosMasComprados: _destacados
          })

        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }

  postAgregarProductoPedido = async (carritoProdctos, setcarritoProdctos, item, pantalla) => {

    this.setState({ loading: true })
    let producto = {
      codigo: item.matnr,
      descripcion: item.maktx,
      precioOferta: item.pOfe,
      precioPublico: item.pPub,
      precioFinal: item.pFin,
      meins: item.meins,
      moneda: item.waers,
      precioPVD: item.precioPVD,
      precioPVP: item.precioPVP,
      precioPublico: item.precioPublico,
      cantidadOriginal: item.cantidad,
      cantidad: item.cantidad,
      pathI: item.pathI,
      precios: item.precios,
      pantalla: pantalla,
      escalas: item.escalas
    };
    AgregarProductoPedido(this.state.dealer, producto, this.state.linea, this.state.asociado)
      .then(result => {
        if (result.mo.type == "success") {
          let _destacados = this.state.productosMasCompradosFiltrados
          let dataIndex = this.state.productosMasCompradosFiltrados.findIndex(x => x.indice == item.indice);
          _destacados[dataIndex].cantidad = 0;
          this.setState({
            productosMasCompradosFiltrados: _destacados,
            // productosMasComprados: _destacados,
            loading: false,
            addToCart: true,
            dataToCard: producto
          })
          // setcarritoProdctos(carritoProdctos + 1)
          setcarritoProdctos(result.dto.carritoProdctos);
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }

  searchProductos = (e) => {
    let text = e.currentTarget.value;

    this.setState({ loading: true });
    if (text) {
      let textData = text.toUpperCase();
      let newData = this.state.productosMasComprados.filter(function (item) {
        const itemData = item.matnr ? item.matnr.toUpperCase() : ''.toUpperCase();
        const itemDescripcion = item.maktx ? item.maktx.toUpperCase() : ''.toUpperCase();

        if (itemData.indexOf(textData) > -1) return item;
        if (itemDescripcion.indexOf(textData) > -1) return item;

      });
      this.setState({ productosMasCompradosFiltrados: newData, search: text, loading: false });
    } else {
      this.setState({ productosMasCompradosFiltrados: this.state.productosMasComprados, search: '', loading: false });
    }
  }
}
